var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOPlogo = function SvgOPlogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 33.5,
    fill: "white",
    stroke: "#C8C8C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5004 21C37.8793 20.9999 39.2446 21.2549 40.5186 21.7505C41.7925 22.246 42.95 22.9724 43.925 23.8882C44.9 24.8039 45.6734 25.8911 46.201 27.0876C46.7286 28.2842 47.0001 29.5666 47 30.8617C47.0005 32.4655 46.5841 34.0452 45.7869 35.4635C44.9896 36.8818 43.8357 38.0958 42.4254 39V36.1109C42.4254 33.4957 41.3194 30.9876 39.3508 29.1383C37.3821 27.2889 34.7119 26.2497 31.9275 26.2493C29.8114 26.2469 27.7443 26.8481 26 27.9734V21H36.5004Z",
    fill: "#4A5B8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0743 41.7489C38.1895 41.7512 40.2557 41.1508 42 40.0271V47H31.5008C30.1218 47.0001 28.7563 46.7451 27.4822 46.2495C26.2081 45.7539 25.0505 45.0275 24.0754 44.1117C23.1003 43.1959 22.3268 42.1087 21.7991 40.9121C21.2714 39.7155 20.9999 38.433 21 37.1379C20.9991 35.5343 21.4152 33.9548 22.2121 32.5366C23.009 31.1183 24.1626 29.9043 25.5726 29V31.8884C25.5733 34.5038 26.68 37.0118 28.6494 38.861C30.6187 40.7101 33.2895 41.7489 36.0743 41.7489Z",
    fill: "#615A55"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOPlogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/OPlogo.d655bb6f.svg";
export { ForwardRef as ReactComponent };